/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApReportCard = /** @class */ (function () {
            function ApReportCard() {
                this.replace = false;
                this.restrict = 'E';
                this.scope = {
                    cardIndex: '@',
                    report: '='
                };
                this.templateUrl = 'app/directives/ap-report-card/ap-report-card.template.html';
                this.controller = Directives.ApReportCard;
                this.controllerAs = 'ctrl';
            }
            ApReportCard.factory = function () {
                var directive = function () {
                    return new ApReportCard();
                };
                directive['$inject'] = [];
                return directive;
            };
            return ApReportCard;
        }());
        angular
            .module('app.Directives')
            .directive('apReportCard', ApReportCard.factory());
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
